import { render, staticRenderFns } from "./SfColorPicker.vue?vue&type=template&id=9224eb92&"
import script from "./SfColorPicker.vue?vue&type=script&lang=js&"
export * from "./SfColorPicker.vue?vue&type=script&lang=js&"
import style0 from "./SfColorPicker.vue?vue&type=style&index=0&id=9224eb92&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports